export function SpringTrainingIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="28" r="3" />
      <path d="M24 10v15" />
      <path d="M18 16c3-3 9-3 12 0" />
      <path d="M14 22c5-5 15-5 20 0" />
      <path d="M12 38c0-4 5-7 12-7s12 3 12 7" />
    </svg>
  );
}
